import { render, staticRenderFns } from "./BaseTrumpetExplain.vue?vue&type=template&id=a4f440b6&scoped=true"
import script from "./BaseTrumpetExplain.vue?vue&type=script&lang=js"
export * from "./BaseTrumpetExplain.vue?vue&type=script&lang=js"
import style0 from "./BaseTrumpetExplain.vue?vue&type=style&index=0&id=a4f440b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f440b6",
  null
  
)

export default component.exports